import { DatePicker } from 'antd-mobile';
import { PickerDate } from 'antd-mobile/es/components/date-picker/util';

interface CustomPickerProps {
  title?: string;
  confirmText?: string;
  cancelText?: string;
  min?: Date;
  max?: Date;
  defaultValue?: Date;
  visible: boolean;
  onClose: () => void;
  onConfirm: (value: PickerDate) => void;
}

export const CustomDatePicker = ({
  title,
  confirmText = '확인',
  cancelText = '취소',
  min,
  max,
  defaultValue,
  visible,
  onClose,
  onConfirm,
}: CustomPickerProps) => {
  return (
    <DatePicker
      style={{
        '--title-font-size': '16px',
        '--header-button-font-size': '16px',
        '--item-height': '48px',
      }}
      mouseWheel
      title={title}
      confirmText={confirmText}
      cancelText={cancelText}
      visible={visible}
      min={min}
      max={max}
      defaultValue={defaultValue}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
